import React from 'react';
import BlockBase from '../BlockBase';

import image1 from './images/149316664_5061191460621066_7360931095495474471_n.jpg';
import image2 from './images/92399274_235181431060521_2654762571251309465_n.jpg';
import image3 from './images/69699910_963274540682334_7047241637895199562_n.jpg';
import image4 from './images/67479514_124135251911329_8706822914597570435_n.jpg';
import image5 from './images/61362448_307093836875961_4748430993607504833_n.jpg';
import image6 from './images/61617800_694744934289636_2771704187793481806_n.jpg';
import image7 from './images/59376402_589107668245386_5461494668174957622_n.jpg';

const data = [
    {
        image: image1,
        url: 'https://www.instagram.com/p/CLKZOZPlwPa/'
    },
    {
        image: image2,
        url: 'https://www.instagram.com/p/B-xqGbxHmwO/'
    },
    {
        image: image3,
        url: 'https://www.instagram.com/p/B2Mg6IHBUsM/'
    },
    {
        image: image4,
        url: 'https://www.instagram.com/p/B1WsT0hBatu/'
    },
    {
        image: image5,
        url: 'https://www.instagram.com/p/BybHnfcB3dA/'
    },
    {
        image: image6,
        url: 'https://www.instagram.com/p/ByX85cUB3sm/'
    },
    {
        image: image7,
        url: 'https://www.instagram.com/p/Bx2Le7LBNoZ/'
    },
];

const InstagramBlock = () => (
    <BlockBase id='instagram' invisibleTitle={true}>
        {data.map(({image, url}) => (
            <div key={url} id={url} className='instagram--item'>
                <a href={url} target='_blank'>
                    <img src={image} alt="" className='img-fluid'/>
                </a>
            </div>
        ))}
    </BlockBase>
);

export default InstagramBlock

